// frontend/src/services/AuthService.js
import apiClient, { setCsrfTokenHeader } from './api'; // Import setCsrfTokenHeader

// Function to completely clear all session data
export function clearAllSessionData() {
  if (typeof window !== 'undefined') {
    // Clear localStorage
    localStorage.clear();
    
    // Clear sessionStorage
    sessionStorage.clear();
    
    // Clear all cookies more aggressively
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      
      // Clear cookie with various combinations
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + window.location.hostname;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=." + window.location.hostname;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;secure";
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;samesite=strict";
    }
  }
}

// Function to fetch CSRF token from backend
export async function fetchAndSetCsrfToken() {
  try {
    // Ensure your backend has this endpoint: /api/auth/csrf-token
    const response = await apiClient.get('/auth/csrf-token'); 
    if (response.data.csrf_token) {
      setCsrfTokenHeader(response.data.csrf_token);
      return true;
    }
  } catch (error) {
    console.error('Failed to fetch and set CSRF token:', error);
    setCsrfTokenHeader(null); // Clear if fetching failed
  }
  return false;
}

export default {
  async login(credentials) {
    const response = await apiClient.post('/auth/login', credentials);
    if (response.data.user) {
      await fetchAndSetCsrfToken(); // Fetch and set CSRF token after successful login
    }
    return response;
  },

  async register(userData) {
    const response = await apiClient.post('/auth/register', userData);
     if (response.data.user) {
      // If auto-login after register, also fetch CSRF
      await fetchAndSetCsrfToken();
    }
    return response;
  },

  //register_as_admin
  async registerAsAdmin(userData) {
    return (await apiClient.post('/auth/register_as_admin', userData)).data;
  },

  async getCompanySettings(cid) {
    // const apiClient = (await import('@/services/api')).default;
    const response = await apiClient.get(`/companies_single/${cid}`);
    return response.data;
  },

  async logout() {
    try {
        // Call server logout endpoint to invalidate session
        await apiClient.post('/auth/logout');
    } catch (err) {
        console.error("Logout API error:", err);
        // Continue with client-side cleanup even if server call fails
    } finally {
        // Always clear client-side state regardless of server response
        setCsrfTokenHeader(null); // Clear CSRF token on logout
        
        // Use comprehensive session clearing
        clearAllSessionData();
        
        // Set logout flag
        if (typeof window !== 'undefined') {
          sessionStorage.setItem('user_logged_out', 'true');
        }
    }
  },

  async getStatus() {
    const response = await apiClient.get('/auth/status');
    if (response.data.user) {
      await fetchAndSetCsrfToken(); // Fetch and set CSRF if session is valid
    } else {
      setCsrfTokenHeader(null); // Clear if no active session
    }
    return response;
  },

  // Export the function for use in API client
  fetchAndSetCsrfToken,
};
